"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorAlert = exports.ErrorAlert = exports.printError = exports.isIError = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Alert_1 = require("./Alert");
function isIError(arg) {
    return arg.name !== undefined && arg.message !== undefined;
}
exports.isIError = isIError;
function printError(error) {
    return error ? error.message : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.printError = printError;
exports.ErrorAlert = function (_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return react_1.default.createElement(Alert_1.Alert, tslib_1.__assign({}, props, { children: printError(children) }));
};
function useErrorAlert(_a) {
    if (_a === void 0) { _a = tslib_1.__assign(tslib_1.__assign({}, { children: undefined }), { Component: exports.ErrorAlert }); }
    var Component = _a.Component, props = tslib_1.__rest(_a, ["Component"]);
    var _b = tslib_1.__read(react_1.useState(props.children ? props.children : undefined), 2), errorAlert = _b[0], setErrorAlert = _b[1];
    return {
        errorAlert: react_1.default.createElement(react_1.default.Fragment, null, errorAlert && react_1.default.createElement(Component, tslib_1.__assign({}, props, { children: errorAlert }))),
        setErrorAlert: function (alert) {
            setErrorAlert(alert);
        },
    };
}
exports.useErrorAlert = useErrorAlert;
//# sourceMappingURL=ErrorAlert.js.map